/**
 * Lista de negócios (/deals/list): valor de URL/estado para incluir todas as pipelines visíveis.
 */
export const DEALS_ALL_PIPELINES_ID = "__all__";

/** Aplica `.eq('pipeline_id', …)` só quando um funil específico está selecionado (não "Todas"). */
export function shouldApplyDealsListPipelineScope(pipelineId: string | undefined): boolean {
  if (!pipelineId || pipelineId === DEALS_ALL_PIPELINES_ID) return false;
  return true;
}
